<template>
	<span>
		<span @click="onLabelClick" v-if="!edit">{{vlabel}}</span>
		<input type="text" v-if="edit" v-model="label" v-on:blur="updateText" ref="labeledit" :placeholder="vplaceholder" v-bind:class="editClass" @keyup.enter="enterHandler"/>
	</span>
</template>

<script>
export default{
	name: 'LabelEdit',
	data: function(){
		return {
			edit: false, // define whether it is in edit mode or not
			label: '', // v-bind data model for input text
			empty: 'Enter some text value', // empty place holder .. replace with your own localization for default
		}
	},
	props: ['text','placeholder', 'id', 'editClass'], // parent should provide :text or :placeholder
	methods: {
		initText: function(){
			if (this.text=='' || this.text==undefined) { this.label = this.vlabel;
			} else { this.label = this.text;
			}
		},
		// when the div label got clicked and trigger the text box
		onLabelClick: function(){
			this.edit = true;
			this.label = this.text;
		},
		// trigger when textbox got lost focus
		updateText: function(){
			this.edit = false;
			this.$emit('text-updated', this.label, this.id);
		},
		enterHandler: function () {
			this.edit = false;
		}
	},
	computed: {
		vplaceholder: function(){
			// check if the placeholder is undefined or empty
			if (this.placeholder==undefined || this.placeholder=='') return this.empty;
			else return this.placeholder;
		},
		vlabel: function(){
			// after text has been updated
			// return text value or place holder value depends on value of the text
			return (this.text==undefined||this.text=='') ? this.vplaceholder : this.text
		}
	},
	mounted: function(){
		// initiate the label view
		this.initText();
	},
	updated: function(){
		var ed = this.$refs.labeledit;
		if(ed!=null){
			ed.focus();
		}
	},
	watch: {
		text: function(value){
			if(value==''||value==undefined){
				this.label = this.vplaceholder
			}
		}
	}
}
</script>
